import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { appointmentForecastFacts } from "../subjects/stopEvent/appointmentForecastFacts";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * Storyboard's forecast crossed a stop's appointment: the projected arrival passed the appointment's end.
 *
 * Minted by the appointment-risk sweep rather than by a vendor, on a stop's transition into late.
 */
export const forecastLateV1 = tmsEventKind(
  { category: "appointment", kind: "forecastLate", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      ...appointmentForecastFacts,
      /**
       * How far past the appointment's end the arrival was projected, as an unsigned ISO 8601 duration.
       *
       * The standard has no negative duration and neither does the validator: a leading or component minus fails the
       * parse. A zero duration is well-formed and parses; the sweep's write rule is what keeps the overrun above the
       * grace period.
       */
      lateBy: z.iso.duration(),
    },
  },
);

export const ForecastLateV1Schema = forecastLateV1.schema;
export const ForecastLateV1FactsSchema = forecastLateV1.facts;

export type ForecastLateV1 = z.infer<typeof ForecastLateV1Schema>;
export type ForecastLateV1Facts = z.infer<typeof ForecastLateV1FactsSchema>;

/** Every version of `forecastLate`, keyed by version. What `catalog.ts` places under `appointment`. */
export const forecastLate = { 1: forecastLateV1 } as const;
